var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMetricsRightStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 588 81"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "metrics-right-stars_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F3E55",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80AFE5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50%",
    x2: "129.061%",
    y2: "50%",
    id: "metrics-right-stars_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081122",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#487FCF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    filterUnits: "objectBoundingBox",
    id: "metrics-right-stars_svg__c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "url(#metrics-right-stars_svg__a)",
    opacity: 0.752,
    x: 240,
    y: 74,
    width: 348,
    height: 7,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5 0C464.27 0 473 8.73 473 19.5S464.27 39 453.5 39h-42c-10.77 0-19.5-8.73-19.5-19.5S400.73 0 411.5 0h42zm0 3h-42c-9.113 0-16.5 7.387-16.5 16.5 0 9.005 7.215 16.326 16.18 16.497l.32.003h42c9.113 0 16.5-7.387 16.5-16.5 0-9.005-7.215-16.326-16.18-16.497L453.5 3z",
    fill: "#3C5475",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "url(#metrics-right-stars_svg__b)",
    opacity: 0.752,
    y: 10,
    width: 458,
    height: 21,
    rx: 10.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#80AFE5",
    filter: "url(#metrics-right-stars_svg__c)",
    cx: 448,
    cy: 20,
    r: 10
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgMetricsRightStars as ReactComponent };